import Api from '../global/api';

export function tariffsLoad () {
    return async dispatch => {

        // Loading
        dispatch({
            type: 'TARIFFS_LOAD',
            status: 'LOADING',
            payload: null
        })


        let active_profile = await Api.getLocal('_bvap');
        if(active_profile !== null){
            Api.req(`/tariffs/${active_profile}`, 'GET').then(
                res => {

                    Api.setLocal('tariffs', res.result);

                    dispatch({
                        type: 'TARIFFS_LOAD',
                        status: 'OK',
                        payload: res.result
                    })
                },
                err => {
                    // Login error
                    dispatch({
                        type: 'TARIFFS_LOAD',
                        status: 'error',
                        payload: typeof err.msg === 'string' ? err.msg : 'Sorry we were unable to load your tariffs'
                    })
                }
            )
        }

    }
}

export function tariffAdd (payload) {
    return dispatch => {

        // Loading
        dispatch({
            type: 'TARIFF_ADD',
            status: 'OK',
            payload: payload
        })

        return 'success';

    }
}

export function tariffUpdate (payload) {
    return async dispatch => {

        // Loading
        dispatch({
            type: 'TARIFF_UPDATE',
            status: 'OK',
            payload: payload
        })
        
    }
}